<template>
  <v-card>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card flat style="border-radius: 0px">
            <v-toolbar
              dense
              class="indigo darken-1 headline"
              primary-title
              uppercase
            >
              <v-toolbar-title class="white--text">
                Associazioni
              </v-toolbar-title>
              <v-spacer></v-spacer>

              <!-- Bottone di aggiunta nuova associazione -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungiAssociazione"
                    small
                    v-on="on"
                    v-bind="attrs"
                  >
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Nuova Associazione</span>
              </v-tooltip>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text style="max-height: 600px; overflow-y: auto">
              <v-row>
                <v-col md="12">
                  <v-data-table
                    :items="items_associazioni"
                    :headers="headers_associazioni"
                  >
                    <!-- Bottone di modifica -->
                    <template v-slot:[`item.edit`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="modificaAssociazione(item)"
                            small
                            v-on="on"
                            v-bind="attrs"
                          >
                            <v-icon color="primary">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Aggiorna</span>
                      </v-tooltip>
                    </template>

                    <!-- Bottoni per visualizzare i disegni -->
                    <template v-slot:[`item.disegno`]="{ item }">
                      <span v-if="item.disegno == null || item.disegno == ''">
                        (N/D)
                      </span>
                      <!-- Bottone per le immagini -->
                      <div
                        style="display: inline-block"
                        v-viewer
                        class="images clearfix"
                        v-else-if="!isPdf(item.disegno) && !isDxF(item.disegno)"
                      >
                        <img
                          style="
                            height: 40px !important;
                            display: block !important;
                            width: 60px !important;
                          "
                          :src="item.disegno"
                          :lazy-src="item.disegno"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        />
                      </div>

                      <!-- Bottone per i PDF -->
                      <v-card
                        @click="openPdf(item)"
                        style="
                          height: 40px !important;
                          width: 80px !important;
                          margin-right: -10rem !important;
                        "
                        v-else-if="isPdf(item.disegno)"
                      >
                        <div style="text-align: center">
                          <v-spacer></v-spacer>
                          <v-icon color="error" x-large>
                            mdi-file-pdf-box
                          </v-icon>
                        </div>
                      </v-card>
                      <!-- Card per i dxf -->
                      <v-card
                        @click="openDxf(item.disegno)"
                        style="
                          height: 40px !important;
                          width: 80px !important;
                          margin-right: -10rem !important;
                        "
                        v-else-if="isDxF(item.disegno)"
                      >
                        <div style="text-align: center">
                          <v-spacer></v-spacer>
                          <v-icon color="error" x-large>
                            mdi-file-cad-box
                          </v-icon>
                        </div>
                      </v-card>
                    </template>

                    <!-- Colonna delle note -->
                    <template v-slot:[`item.note`]="{ item }">
                      {{
                        item.note == null || item.note == ""
                          ? "N/D"
                          : item.note.substr(0, 20) +
                            (item.note.length > 20 ? "..." : "")
                      }}
                    </template>

                    <!-- Bottone di eliminazione -->
                    <template v-slot:[`item.elimina`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="clickEliminaAssociazione(item)"
                            small
                            v-on="on"
                            v-bind="attrs"
                          >
                            <v-icon color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancella</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog di modifica dell'Associazione -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialog_edit_assocazione"
      width="900"
    >
      <v-overlay :value="overlay" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">
            Dettaglio Associazione
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaAssociazione" small v-on="on" v-bind="attrs">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialog_edit_assocazione = false" small>
                <v-icon v-on="on" v-bind="attrs" depressed class="" color="red">
                  mdi-window-close
                </v-icon>
              </v-btn>
            </template>
            <span>Cancellare </span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container fluid>
            <v-row>
              <v-col cols="4">
                <!-- Input del codice disegno -->
                <v-text-field
                  dense
                  hide-details
                  label="Codice"
                  v-model="associazione_sel.cod_disegno"
                />
              </v-col>
              <v-col cols="4">
                <!-- Input del codice alternativo -->
                <v-text-field
                  dense
                  hide-details
                  label="Codice Alternativo"
                  v-model="associazione_sel.cod_alternativo"
                />
              </v-col>
              <v-col cols="4">
                <!-- Input della descrizione codice alternativo -->
                <v-text-field
                  dense
                  hide-details
                  label="Des. Cod. Alternativo"
                  v-model="associazione_sel.des_alternativo"
                />
              </v-col>
            </v-row>
            <!--<v-row>
              <v-col cols="1">-->
            <!-- Bottone per caricare un nuovo allegato -->
            <!--<v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog_allegati = true"
                    >
                      <v-icon color="primary">mdi-paperclip</v-icon>
                    </v-btn>
                  </template>
                  <span>Associa Disegno</span>
                </v-tooltip>
              </v-col>

              <v-col
                cols="1"
                v-if="
                  associazione_sel.disegno != null &&
                  associazione_sel.disegno != ''
                "
              >-->
            <!-- Card per la visualizzazione delle immagini -->
            <!--<v-card
                  v-if="
                    !isPdf(associazione_sel.disegno) &&
                    !isDxF(associazione_sel.disegno)
                  "
                  class="d-flex justify-center"
                >
                  <div
                    v-viewer
                    class="images clearfix d-flex align-items-center"
                  >
                    <img
                      id="immagine"
                      style="
                        height: 100% !important;
                        width: 100%;
                        display: block !important;
                      "
                      :src="associazione_sel.disegno"
                      :lazy-src="associazione_sel.disegno"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    />
                  </div>
                </v-card>-->
            <!-- Card per i PDF -->
            <!--<v-card
                  @click="openPdf(associazione_sel)"
                  style="
                    height: 40px !important;
                    width: 80px !important;
                    margin-right: -10rem !important;
                  "
                  v-if="
                    isPdf(associazione_sel.disegno) &&
                    !isDxF(associazione_sel.disegno)
                  "
                >
                  <div style="text-align: center">
                    <v-spacer></v-spacer>
                    <v-icon color="error" x-large> mdi-file-pdf-box </v-icon>
                  </div>
                </v-card>

                <v-card
                  @click="openDxf(associazione_sel.disegno)"
                  style="
                    height: 40px !important;
                    width: 80px !important;
                    margin-right: -10rem !important;
                  "
                  v-show="isDxF(associazione_sel.disegno)"
                >
                  <div style="text-align: center">
                    <v-spacer></v-spacer>
                    <v-icon color="error" x-large> mdi-file-cad-box </v-icon>
                  </div>
                </v-card>
              </v-col>
            </v-row>-->
            <v-row class="mt-5" dense>
              <v-col cols="4">
                <!-- Input della ragione sociale -->
                <v-text-field
                  dense
                  hide-details
                  @keyup.enter="searchAnagrafica"
                  label="Ragione Sociale"
                  v-model="associazione_sel.ragione_sociale"
                >
                  <template v-slot:append>
                    <!-- Icona di ricerca dell'anagrafica -->
                    <v-icon color="primary" @click="searchAnagrafica">
                      mdi-magnify
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <!-- Input dell'indirizzo -->
                <v-text-field
                  dense
                  hide-details
                  label="Indirizzo"
                  readonly
                  v-model="associazione_sel.indirizzo"
                />
              </v-col>
              <v-col cols="4">
                <!-- Input della località -->
                <v-text-field
                  dense
                  hide-details
                  label="Località"
                  readonly
                  v-model="associazione_sel.localita"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  dense
                  hide-details
                  label="Note"
                  outlined
                  rows="2"
                  style="border-radius: 0px"
                  v-model="associazione_sel.note"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione della ragione sociale -->
    <v-dialog persistent v-model="dialog_ragione_sociale" width="90%">
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">Ragione Sociale</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialog_ragione_sociale = false" small>
                <v-icon v-on="on" v-bind="attrs" depressed class="" color="red">
                  mdi-window-close
                </v-icon>
              </v-btn>
            </template>
            <span>Cancellare</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-data-table
            :headers="headers_ragione_sociale"
            :items="items_ragione_sociale"
          >
            <template v-slot:[`item.selezione`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" @click="selezionaAnagrafica(item)" small>
                    <v-icon dark v-bind="attrs" v-on="on" small color="#009900">
                      mdi-check
                    </v-icon>
                  </v-btn>
                </template>
                <span> imposta Fornitura </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog persistent v-model="dialog_conferma_eliminazione" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="font-size: 18px">
            Confermi l'eliminazione di questo elemento?
          </span>
        </v-card-text>
        <v-divider class="mb-5"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-5"
            @click="dialog_conferma_eliminazione = false"
            small
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
          <v-btn @click="eliminaAssociazione" small>
            <v-icon color="success"> mdi-check </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione dell'allegato -->
    <v-dialog persistent v-model="dialog_allegati" width="400">
      <v-card>
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">Allegati</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialog_allegati = false" small>
                <v-icon v-on="on" v-bind="attrs" color="error">
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-file-input
            accept="*"
            @change="onFileChange(allegato)"
            style="display: inline-block; width: 400px"
            type="file"
            v-model="allegato"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog per visualizzare i DXF -->
    <v-dialog v-model="dialog_dxf" width="800">
      <DxfViewerVue ref="viewer" :dxfUrl="dxf_url" />
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Loader -->
    <v-overlay :value="overlay" style="">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
class Associazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      {
        nome: "cod_alternativo",
        default_val: "",
      },
      { nome: "cod_disegno", default_val: null },
      { nome: "codice", default_val: "" },
      { nome: "des_alternativo", default_val: "" },
      { nome: "disegno", default_val: "" },
      { nome: "dum", default_val: null },
      { nome: "id_anagrafica", default_val: null },
      { nome: "id_articolo", default_val: null },
      { nome: "id_disegno", default_val: -1 },
      { nome: "id_gestione_magazzino", default_val: null },
      { nome: "indice_modifica", default_val: null },
      { nome: "indirizzo", default_val: null },
      { nome: "localita", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "quantita_stock_massimo", default_val: null },
      { nome: "quantita_stock_minimo", default_val: null },
      { nome: "ragione_sociale", default_val: null },
      { nome: "revisione_articolo", default_val: null },
      { nome: "tipo_disegno", default_val: 0 },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}
export default {
  components: {
    SnackbarQV,
  },
  props: ["data"],
  name: "AssociazioniDisegni",
  data() {
    return {
      // Variabili di supporto
      allegato: null,
      associazione_sel: new Associazione(),
      dxf_url: "",

      // Modals
      dialog_allegati: false,
      dialog_conferma_eliminazione: false,
      dialog_dxf: false,
      dialog_edit_assocazione: false,
      dialog_ragione_sociale: false,
      menu: false,
      menu2: false,
      overlay: false,

      // Array
      headers_associazioni: [
        {
          value: "edit",
          sortable: false,
        },
        /*{
          text: "Disegno",
          value: "disegno",
          sortable: false,
        },*/
        {
          text: "Codice",
          value: "cod_disegno",
          sortable: false,
        },
        {
          text: "Codice Alternativo",
          value: "cod_alternativo",
          sortable: false,
        },
        {
          text: "Des. Cod. Alterntivo",
          value: "des_alternativo",
          sortable: false,
        },
        {
          text: "Ragione Sociale",
          value: "ragione_sociale",
          sortable: false,
        },
        {
          text: "Note",
          value: "note",
          sortable: false,
        },
        {
          value: "elimina",
          sortable: false,
        },
      ],
      headers_ragione_sociale: [
        {
          width: "100px",
          text: "Actions",
          value: "selezione",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "_tipo",
          sortable: false,
        },
        {
          text: "Codice",
          value: "codice",
          sortable: false,
        },
        {
          text: "Ragione sociale",
          value: "ragione_sociale",
          sortable: false,
        },
        {
          text: "Indrizzo",
          value: "indirizzo",
          sortable: false,
        },
        {
          text: "Località",
          value: "localita",
          sortable: false,
        },
      ],
      items_associazioni: new Array(),
      items_gestione_magazzino: new Array(),
      items_ragione_sociale: new Array(),
    };
  },
  methods: {
    aggiungiAssociazione() {
      this.associazione_sel = new Associazione();
      this.dialog_edit_assocazione = true;
    },
    b64toBlob(b64Data, sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });
      return blob;
    },
    clickEliminaAssociazione(item) {
      this.dialog_conferma_eliminazione = true;
      this.associazione_sel = new Associazione(item);
    },
    eliminaAssociazione() {
      const obj_tmp = {
        id_disegno: this.associazione_sel.id_disegno,
        validita: 0,
      };

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticoliassociazione",
          token: localStorage.getItem("user_token"),
          id_articolo: this.data.id_articolo,
          articolo_disegni: [obj_tmp],
        },
      };

      this.dialog_conferma_eliminazione = false;
      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Modifica effettuata con successo!"
            );
            this.getAssociazioni();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getAssociazioni() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoliassociazione",
          token: localStorage.getItem("user_token"),
          id_articolo: this.data.id_articolo,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_associazioni = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    modificaAssociazione(item) {
      this.associazione_sel = new Associazione(item);
      this.dialog_edit_assocazione = true;
    },
    getTabella() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "ARTICOLO_GESTIONE_MAGAZZINO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_gestione_magazzino = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    hasExtension(file, exts) {
      return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
        file.name
      );
    },
    isPdf(elem) {
      console.log("entrato 1");
      if (elem) {
        if (elem.startsWith("data:application/pdf")) {
          return true;
        } else {
          return false;
        }
      }
    },
    isDxF(elem) {
      if (elem) {
        if (elem.startsWith("data:application/octet-stream")) {
          return true;
        } else {
          return false;
        }
      }
    },
    onFileChange(val) {
      // Controllo che il file abbia l'estensione giusta.
      if (
        !this.hasExtension(val, [
          ".gif",
          ".jpeg",
          ".JPEG",
          ".jpg",
          ".JPG",
          ".pdf",
          ".png",
          ".PNG",
          ".dxf",
        ])
      ) {
        this.$refs.SnackbarQV.print("orange", "Tipo di file non accettato.");
        this.dialog_allegati = false;
        return;
      }

      // Se il file ha l'estensione giusta, procedo con lalogica.
      let that = this;
      let reader = new FileReader();

      reader.onload = function () {
        if (that.hasExtension(val, [".pdf"])) {
          /* Se il file è un PDF lo registro senza eseguire la logica
           * per cambiare le dimensioni del css per la miniatura. */
          that.associazione_sel.disegno = reader.result;
        } else {
          /* Se invece è un'immagine, creo una Image e la
           * uso per adattare le dimensioni alla miniatura.*/
          let image = new Image();

          image.onload = function () {
            let width, height;
            let ratio = image.width / image.height;
            if (image.width > image.height) {
              width = Math.min(500, image.width);
              height = width / ratio;
            } else {
              height = Math.min(500, image.height);
              width = height * ratio;
            }

            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);

            that.disegno = ctx.canvas.toDataURL();
            that.resizeImage(image, "immagine");
          };

          image.src = reader.result;
          that.associazione_sel.disegno = image.src;
        }
      };

      reader.onerror = function (error) {
        console.error(error);
      };

      reader.readAsDataURL(val);
      this.dialog_allegati = false;
    },
    openDxf(item) {
      const url = item;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "dxffile.dxf", { type: "" });
          this.dxf_url = URL.createObjectURL(file);
        });
      this.dialog_dxf = true;
    },
    openPdf(item) {
      this.iframeUrl = item.disegno.substring(28);
      const blob = this.b64toBlob(this.iframeUrl);
      const blob_url = URL.createObjectURL(blob);
      window.open(blob_url, "_blank");
    },
    resizeImage(img, id) {
      if (img) return;

      if (img.width >= img.height && img.width > 100) {
        let width_nuova = 100;
        // Proporzione -> width_nuova : width = height_nuova : height
        let height_nuova = (width_nuova * img.height) / img.width;

        document.getElementById(id).style.width = width_nuova + "px";
        document.getElementById(id).style.height = height_nuova + "px";
      } else if (img.height > img.width && img.height > 100) {
        let height_nuova = 100;
        // Proporzione -> width_nuova : width = height_nuova : height
        let width_nuova = (height_nuova * img.width) / img.height;
        document.getElementById(id).style.width = width_nuova + "px";
        document.getElementById(id).style.height = height_nuova + "px";
      } else {
        document.getElementById(id).style.width = img.width + "px";
        document.getElementById(id).style.height = img.height + "px";
      }
    },
    salvaAssociazione() {
      // Controllo il numero disegno.
      if (
        this.associazione_sel.cod_disegno == null ||
        this.associazione_sel.cod_disegno == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Inserire il Codice.");
        return;
      }

      // Controllo l'associazione dell'anagrafica.
      if (
        this.associazione_sel.id_anagrafica == null ||
        this.associazione_sel.id_anagrafica == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Inserire la Ragione Sociale.");
        return;
      }

      let chk_is_duplicato = false;

      // Controllo che l'anagrafica non esista già.
      this.items_associazioni.forEach((a) => {
        if (
          a.id_disegno != this.associazione_sel.id_disegno &&
          a.id_anagrafica == this.associazione_sel.id_anagrafica &&
          a.cod_disegno == this.associazione_sel.cod_disegno
        ) {
          chk_is_duplicato = true;
        }
      });

      if (chk_is_duplicato) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Questo numero di disegno esiste già per questa anagrafica."
        );
        return;
      }

      const obj_tmp = new Associazione(this.associazione_sel);
      obj_tmp.id_articolo = this.data.id_articolo;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticoliassociazione",
          token: localStorage.getItem("user_token"),
          articolo_disegni: [obj_tmp],
        },
      };

      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.getAssociazioni();
          this.overlay = false;
          this.dialog_edit_assocazione = false;
          this.$refs.SnackbarQV.print("success", "Aggiornamento effettuato.");
        }
      });

      this.dialog_edit_assocazione = false;
    },
    selezionaAnagrafica(val) {
      this.associazione_sel.codice = val.codice;
      this.associazione_sel.id_anagrafica = val.id_anagrafica;
      this.associazione_sel.indirizzo = val.indirizzo;
      this.associazione_sel.localita = val.localita;
      this.associazione_sel.ragione_sociale = val.ragione_sociale;
      this.dialog_ragione_sociale = false;
    },
    searchAnagrafica() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",
          token: localStorage.getItem("user_token"),
          des_anagrafica: this.associazione_sel.ragione_sociale,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna ragione sociale corrisponde alla ricerca."
              );
              return;
            } else {
              this.items_ragione_sociale = res.data;
              this.dialog_ragione_sociale = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  watch: {},
  computed: {},
  mounted() {
    this.getAssociazioni();
    this.getTabella();
  },
};
</script>
<style scoped>
</style>